import { render, staticRenderFns } from "./last_dues_recognition_log.vue?vue&type=template&id=2bce3bd2&"
import script from "./last_dues_recognition_log.vue?vue&type=script&lang=js&"
export * from "./last_dues_recognition_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports